import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MailLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mail_lock"}/>
}
